export default function Footer() {
  const footerLinks = [
    {
      title: '快捷导航',
      links: [
        { label: '独家揭秘专题', href: '#cards' },
        { label: '影视追踪问答', href: '#faq' },
        { label: '热门榜单', href: '#ranking' },
        { label: '焦点专题', href: '#carousel' },
        { label: '读者热评', href: '#comments' },
      ],
    },
    {
      title: '内容板块',
      links: [
        { label: '实时追踪快讯', href: '#updates' },
        { label: '热门话题', href: '#topics' },
        { label: '影视专题索引', href: '#index' },
        { label: '幕后花絮', href: '#media' },
        { label: '移动客户端', href: '#app' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '投稿爆料', href: '#contact' },
        { label: '平台特色', href: '#features' },
      ],
    },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-lg text-white"></i>
                </div>
                <span className="text-xl font-heading font-bold">51电影网</span>
              </div>
              <p className="text-sm text-secondary-300 leading-relaxed mb-4">
                51电影网集电影上映、幕后花絮、明星动态与八卦于一身，
                实时追踪票房黑马、争议事件，提供独家幕后揭秘合集，
                影视资讯一网打尽。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white mb-4 font-heading">{group.title}</h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleClick(e, link.href)}
                        className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <h4 className="text-sm font-semibold text-white mb-3 font-heading">合作伙伴</h4>
            <p className="text-xs text-secondary-400 mb-6">诚邀各大影视平台、媒体机构与品牌方携手合作，共创影视资讯新生态。</p>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-secondary-400">
              <p>&copy; 2026 51电影网. All rights reserved.</p>
              <p>电影上映幕后花絮明星动态 — 电影评分票房黑马争议事件实时追踪</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}